import { Configuration } from '../app/_common/models/configuration';

export const configuration: Configuration = {
    stage: 'staging',
    apiUrlAuth: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlItsm: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlIts2: 'https://api.staging.rd.kaas.antemeta.io/v3',
    apiUrlObjs: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlHist: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlRept: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlSecu: 'wss://api.staging.rd.kaas.antemeta.io/v2/secu/attacks/ws',
    apiUrlPrtg: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlOstk: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlDafa: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlCmdb: 'https://api.staging.rd.kaas.antemeta.io/v2',
    apiUrlSurv: 'https://api.staging.rd.kaas.antemeta.io/v2',
    urlSatisfactionSurv: 'https://surveys.staging.rd.kaas.antemeta.io/satisfaction?entityId=',
    trackingUrl: '',
    trackingSiteId: '',
    sentryDsn: '',
    rocketChatUrl: '',
    rocketChatScriptUrl: ''
};


